import { useQuery } from '@tanstack/react-query';
import { fetchSrmByEmailAddressGraphQL } from '../services/srm.graphql.service';
import type { SrmData } from '../types';

/**
 * Query key factory for SRM data queries
 */
export const srmQueryKeys = {
  all: ['srm'] as const,
  byEmail: (email: string) => [...srmQueryKeys.all, 'email', email] as const,
};

/**
 * Custom hook for fetching SRM data using TanStack Query
 * @param emailAddress - Email address to fetch SRM data for (can be null/undefined)
 * @returns Query result object with data, loading state, and error
 */
export const useSrmDataQuery = (emailAddress: string | null | undefined) => {
  return useQuery<SrmData | null, Error>({
    queryKey: srmQueryKeys.byEmail(emailAddress || ''),
    queryFn: () => fetchSrmByEmailAddressGraphQL(emailAddress!),
    enabled: !!emailAddress,
    staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
    gcTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
    retry: 2, // Retry failed requests twice
  });
};
